import * as getters from "../../baseQuestion/dynamicDDL/store/getters";
import * as mutations from "../../baseQuestion/dynamicDDL/store/mutations";
import * as actions from "../../baseQuestion/dynamicDDL/store/actions";
import { state as dynamic_ddl_state } from "../../baseQuestion/dynamicDDL/store/state";

function state() {
	return Object.assign(
		{
			option_source: {
				type: "major",
				filter: [
					{
						operand: "institution",
						operator: "=",
						argument: "UMS03"
					}
				]
			}
		},
		dynamic_ddl_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
